import React from 'react';
import { OverviewGridItem } from './components';
import Card from '../../../../../components/Card';
import UXSignals from '../../../../../components/UXSignals';

export function UserInterviewSection({
  studyId,
  mode,
  scriptUrl,
  getUxSignalStatus,
}) {
  return (
    <OverviewGridItem>
      <Card padding={0} height="100%">
        <UXSignals
          studyId={studyId}
          mode={mode}
          scriptUrl={scriptUrl}
          getUxSignalStatus={getUxSignalStatus}
        />
      </Card>
    </OverviewGridItem>
  );
}
